/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 15/02/22
 */

import { Button } from '@chakra-ui/react';
import React from 'react';
import { getMailBody } from '@/utils/openMail';
import { formatFirstName } from '@/wpt-lib/utils/formatName';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';

const RequestDetailsUpdate = ({ assignment }: { assignment?: Assignment }) => {
    const supervisors = assignment?.supervisors?.sort((s) => (s.isAutoAssigned ? -1 : 1)).map((s) => s.user);
    const subject = '[WPT] Request and Approval to Update Staff Details - Workload Allocation';
    const message = `Dear ${formatFirstName(
        supervisors?.[0],
    )},%0D%0A%0D%0AThe UTS WPT has identified you as my supervisor and currently my workload allocation in the tool is not correct. Can you please approve the following changes so that so that my supervisor or our local area administrator can make the changes in the tool:`;
    return (
        <Button
            h={12}
            whiteSpace="normal"
            colorScheme="blue"
            variant="solid"
            onClick={() => window.open(getMailBody(subject, supervisors?.[0].email ?? '', message))}
        >
            Request Allocation Update
        </Button>
    );
};

export default RequestDetailsUpdate;
